import React, { PropsWithChildren } from 'react';

export const AvatarsGroup = ({
  maxLength = 4,
  children,
}: PropsWithChildren<{ maxLength?: number }>) => {
  const childrenArray = React.Children.toArray(children);

  const visibleChildren = childrenArray.slice(0, maxLength);

  const overflowCount = childrenArray.length - maxLength;

  return (
    <div className="flex flex-row items-center space-x-[-8px]">
      {visibleChildren.map((child, index) => (
        <div key={index} style={{ zIndex: visibleChildren.length - index }}>
          {child}
        </div>
      ))}
      {overflowCount > 0 && (
        <div className="flex size-7 items-center justify-center rounded-full bg-gray-200 text-sm text-gray-500">
          +{overflowCount}
        </div>
      )}
    </div>
  );
};
